module.exports = __webpack_public_path__ + "static/image/company/pc/image_vision_3.jpg?88b4de81";